module.exports = __webpack_public_path__ + "static/media/manOnTable.7ae65144.svg";